import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-20 px-4 bg-[#0f0f18]" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-3">
          {/* Who This Is For */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="bg-[#161622] border border-[#00c853]/30 rounded-2xl p-8 shadow-[0_0_30px_rgba(0,200,83,0.05)]" data-id="element-4">
            <h3 className="text-2xl font-playfair font-bold mb-8 text-white flex items-center gap-3" data-id="element-5">
              <div className="bg-[#00c853]/20 p-2 rounded-full" data-id="element-6">
                <CheckIcon className="w-6 h-6 text-[#00c853]" data-id="element-7" />
              </div>
              Esto ES para ti si:
            </h3>
            <ul className="space-y-5" data-id="element-8">
              {['Mujeres que sienten que "pierden el control" frente al dulce por las noches.', 'Personas con inflamación abdominal constante y fatiga crónica.', 'Mujeres profesionales que sufren caídas de energía severas a las 4 PM.', 'Cualquier persona cansada de sentirse culpable por su alimentación.'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-9">
                  <CheckIcon className="w-5 h-5 text-[#00c853] shrink-0 mt-1" data-id="element-10" />
                  <span className="text-[#e0e0e0] font-inter leading-relaxed" data-id="element-11">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who This Is NOT For */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: 0.2
        }} className="bg-[#161622] border border-[#ff6b6b]/30 rounded-2xl p-8 shadow-[0_0_30px_rgba(255,107,107,0.05)]" data-id="element-12">
            <h3 className="text-2xl font-playfair font-bold mb-8 text-white flex items-center gap-3" data-id="element-13">
              <div className="bg-[#ff6b6b]/20 p-2 rounded-full" data-id="element-14">
                <XIcon className="w-6 h-6 text-[#ff6b6b]" data-id="element-15" />
              </div>
              Esto NO es para ti si:
            </h3>
            <ul className="space-y-5" data-id="element-16">
              {['Personas que buscan una dieta de pérdida de peso milagrosa sin cambiar hábitos de 3 días.', 'Quienes no están dispuestos a invertir 15 minutos en leer las instrucciones biológicas.', 'Personas con condiciones médicas graves que requieren supervisión nutricional clínica estricta.'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-17">
                  <XIcon className="w-5 h-5 text-[#ff6b6b] shrink-0 mt-1" data-id="element-18" />
                  <span className="text-[#a0a0b0] font-inter leading-relaxed" data-id="element-19">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}